import { useEffect, useState } from 'react';
import { Box, Grid, Paper, Rating, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Loading, UserNavbar } from '../../../../../components';
import { GROUP_USER } from '../../../../../config/appGroupConfig';
import { getUsersRatingByRole } from '../../../../../core/users/action';
import ModalReview from './ModalReview';

const inputStyles = {
  backgroundColor: '#fffdfd98',
  borderRadius: 50,
  width: '100vw',
  height: 95,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#EE7B57',
};

const styleCenterAlign = {
  display: 'flex',
  alignItems: 'center',
};

const reviewCard = {
  backgroundColor: '#FCE5DD',
  p: 3,
  mb: 2,
  width: '85%',
  borderRadius: '50px',
  cursor: 'pointer',
};

const reviewContainer = {
  backgroundColor: '#d3d3d38a',
  overflowY: 'scroll',
  mx: 1,
  height: '30vw',
  borderRadius: '10px',
  p: 1,
};

function ManageReviews() {
  const dispatch = useDispatch();
  const { ratings, loading } = useSelector((store) => store.users);
  const [ratingsVenues, setRatingsVenues] = useState([]);
  const [ratingsVendors, setRatingsVendors] = useState([]);
  const [selectedReviewee, setSelectedReviewee] = useState();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(getUsersRatingByRole());
  }, [dispatch]);

  const openModalDetails = (reviewee) => {
    setOpen(true);
    setSelectedReviewee(reviewee);
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (ratings && ratings.length > 0) {
      setRatingsVenues(
        ratings.filter(
          (u) =>
            u?.role?.name === GROUP_USER.VENUE &&
            u?.ratingsReceived &&
            u?.ratingsReceived.length > 0,
        ),
      );

      setRatingsVendors(
        ratings.filter(
          (u) =>
            u?.role?.name === GROUP_USER.VENDOR &&
            u?.ratingsReceived &&
            u?.ratingsReceived.length > 0,
        ),
      );
    }
  }, [ratings]);

  return (
    <Layout>
      {loading && <Loading />}
      <UserNavbar />
      {open && <ModalReview open={open} reviewee={selectedReviewee} handleClose={handleClose} />}

      <Grid container justifyContent="center" marginTop={20} spacing={2}>
        <Grid item xs={9} style={inputStyles} marginBottom={3}>
          <h1>Manage Reviews</h1>
        </Grid>
        <Grid container>
          <Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
            <Grid item xs={9} style={inputStyles} marginBottom={3} sx={{ border: 1 }}>
              <h2>Venues</h2>
            </Grid>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
            <Grid item xs={9} style={inputStyles} marginBottom={3} sx={{ border: 1 }}>
              <h2>Vendors</h2>
            </Grid>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
            <Grid item xs={10} sx={reviewContainer}>
              {ratingsVenues.map((r) => (
                <Paper key={r.id} onClick={() => openModalDetails(r)} sx={reviewCard}>
                  <Typography variant="h6">{r.venue.name}</Typography>
                  <Typography variant="body2" sx={styleCenterAlign}>
                    <Rating name="read-only" value={r.averageScore} readOnly size="medium" />
                    <Box sx={{ ml: 2 }}> {`${r.ratingsReceived.length} reviews`}</Box>
                  </Typography>
                </Paper>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
            <Grid item xs={10} sx={reviewContainer}>
              {ratingsVendors.map((r) => (
                <Paper key={r.id} onClick={() => openModalDetails(r)} sx={reviewCard}>
                  <Typography variant="h6">{`${r.name} ${r.last_name} 
            ${r.vendor_company_name ? `(${r.vendor_company_name})` : ``}`}</Typography>
                  <Typography variant="body2" sx={styleCenterAlign}>
                    <Rating name="read-only" value={r.averageScore} readOnly size="medium" />
                    <Box sx={{ ml: 2 }}> {`${r.ratingsReceived.length} reviews`}</Box>
                  </Typography>
                </Paper>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}

ManageReviews.propTypes = {};

export default ManageReviews;
